module.exports = __webpack_public_path__ + "img/kf.08a633d6.png";